import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUser, faHeart, faCog } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  
  // Simple admin check - in real app, this would come from auth context
  const [isAdmin, setIsAdmin] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    // TODO: Implement search functionality
    console.log('Searching for:', searchQuery);
  };

  // Toggle admin mode for demo (in real app, this would be handled by authentication)
  const toggleAdminMode = () => {
    setIsAdmin(!isAdmin);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo" onClick={() => navigate('/')}>
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="MAnime Logo" />
        </div>
        
        <form className="search-bar" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search for anime..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit">
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </form>

        <div className="header-actions">
          <button 
            className="action-btn favorites-btn"
            onClick={() => navigate('/profile?tab=favorites')}
            title="Yêu thích"
          >
            <FontAwesomeIcon icon={faHeart} />
            <span className="action-text">Yêu thích</span>
          </button>
          
          {/* Only show admin button for admin users */}
          {isAdmin && (
            <button 
              className="action-btn admin-btn"
              onClick={() => navigate('/admin')}
              title="Quản trị"
            >
              <FontAwesomeIcon icon={faCog} />
              <span className="action-text">Admin</span>
            </button>
          )}

          <button 
            className="action-btn profile-btn"
            onClick={() => navigate('/profile')}
            title="Trang cá nhân"
          >
            <FontAwesomeIcon icon={faUser} />
            <span className="action-text">Tài khoản</span>
          </button>

          {/* Demo toggle for admin mode - remove in production */}
          <button 
            className={`action-btn toggle-admin ${isAdmin ? 'admin-mode' : 'user-mode'}`}
            onClick={toggleAdminMode}
            title={isAdmin ? "Chuyển sang User" : "Chuyển sang Admin"}
          >
            {isAdmin ? 'User' : 'Admin'}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 